import ReactDOM from 'react-dom';
import React from 'react';
import classnames from 'classnames';

function getContainer () {
  return window.document.getElementById('toast-container');
}

function createWrapper () {
  const container = getContainer();

  const wrapper = document.createElement('div');
  wrapper.className = 'toast-wrapper';

  container.appendChild(wrapper);
  return wrapper;
}

function Toast (props) {
  const { message, show } = props;

  return <div className={classnames({ 'toast-message': true, show })}>
    {message}
  </div>;
}

function renderToast (message, show, wrapper) {
  ReactDOM.render(
    <Toast message={message} show={show} />,
    wrapper
  );
}

export function showToast (message, duration = 2000) {
  const wrapper = createWrapper();

  // css transition 실행하기 위해 먼저 height: 0 상태의 wrapper를 만듬
  renderToast(message, false, wrapper);

  // height: 0 상태의 wrapper 렌더링이 끝나면 height를 설정함으로써 in transition 실행
  setTimeout(() => {
    renderToast(message, true, wrapper);
  }, 0);

  // 지정된 시간 이후에 토스트 메시지 삭제처리
  setTimeout(() => {
    renderToast(message, false, wrapper);

    // css transition이 끝난 이후에 wrapper element를 삭제한다.
    setTimeout(() => {
      getContainer().removeChild(wrapper);
    }, 500);
  }, duration);
}

export function ToastContainer () {
  return <div id="toast-container"></div>;
}
